import { render, staticRenderFns } from "./index_leadingProduct.vue?vue&type=template&id=739d74db&scoped=true"
import script from "./index_leadingProduct.vue?vue&type=script&lang=js"
export * from "./index_leadingProduct.vue?vue&type=script&lang=js"
import style0 from "./index_leadingProduct.vue?vue&type=style&index=0&id=739d74db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739d74db",
  null
  
)

export default component.exports